import { Tag, Theme } from 'team-hero-ui';

import type { IProjectMission } from 'interfaces/ProjectMission.interface';
import type { IColumnDefinitionType } from 'interfaces/Table/DataTableColumn.interface';
import { StatusCellRenderer } from 'components/cellRenderers/StatusCellRenderer/StatusCellRenderer';
import { searchColumnsWidths } from './utils';
import { DateCellRenderer } from 'components/cellRenderers/DateCellRenderer/DateCellRenderer';
import { getStatusColor } from './getStatusColor.helper';
import { LeaderCellRenderer } from 'components/cellRenderers/LeaderCellRenderer/LeaderCellRenderer';
import { GrayedCellRenderer } from 'components/cellRenderers/wta';
import { TruncatedCellStyled } from 'components/Table/components/TableBody/TableBody.styled';
import { ProjectTitleTagStyled } from '../components/ProjectTitleTag.styled';
import { LocationCellRenderer } from 'components/cellRenderers/LocationCellRenderer/LocationCellRenderer';
import { getLocationIdFromIriOrNumber } from 'helpers/location/getLocationIdFromIri.helper';

const customWidths = searchColumnsWidths;
const visibility = true;
const label = '';

export const missionsSearchColumnsFactory = (
  isSmScreenSize: boolean
): IColumnDefinitionType<IProjectMission>[] => {
  return [
    {
      key: 'status',
      label,
      visibility: isSmScreenSize,
      minWidth: customWidths.STATUSWIDE,
      width: customWidths.STATUSWIDE,
      cellType: 'custom',
      cellRenderer: ({ status }) => StatusCellRenderer(getStatusColor(status)),
    },
    {
      key: 'projectTitle',
      label,
      visibility,
      cellType: 'custom',
      minWidth: isSmScreenSize ? customWidths.M : customWidths.XS,
      cellRenderer: ({ project }) => (
        <ProjectTitleTagStyled>
          <Tag>
            <TruncatedCellStyled>{project.title}</TruncatedCellStyled>
          </Tag>
        </ProjectTitleTagStyled>
      ),
    },
    {
      key: 'title',
      label,
      visibility,
      cellType: 'string',
      minWidth: isSmScreenSize ? customWidths.M : customWidths.XS,
    },
    {
      key: 'start',
      label,
      visibility,
      cellType: 'custom',
      minWidth: isSmScreenSize ? customWidths.DATE : undefined,
      width: isSmScreenSize ? undefined : '44px',
      cellRenderer: (mission) =>
        isSmScreenSize ? (
          DateCellRenderer({
            date: mission.start,
          })
        ) : (
          <GrayedCellRenderer
            bgColor={Theme.colors.primary.white}
            color={Theme.colors.greyShades.grey3}
          >
            {DateCellRenderer({
              date: mission.start,
              format: 'dateShort',
            })}
          </GrayedCellRenderer>
        ),
    },
    {
      key: 'end',
      label,
      visibility,
      cellType: 'custom',
      minWidth: customWidths.DATE,
      width: isSmScreenSize ? undefined : '0px',
      cellRenderer: (mission) => (
        <div style={{ display: isSmScreenSize ? 'block' : 'none' }}>
          {DateCellRenderer({ date: mission.end })}
        </div>
      ),
    },
    {
      key: 'addressCity',
      label,
      visibility: isSmScreenSize,
      cellType: 'string',
      minWidth: customWidths.S,
      cellRenderer: ({ location }) => (
        <LocationCellRenderer
          locationId={getLocationIdFromIriOrNumber(location)}
          displayCity
        />
      ),
    },
    {
      key: 'leader',
      label,
      visibility: isSmScreenSize,
      width: customWidths.AVATAR,
      minWidth: customWidths.AVATAR,
      cellType: 'custom',
      cellRenderer: ({ leader }) => (
        <LeaderCellRenderer embeddedContact={leader} />
      ),
    },
  ];
};
